/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ArchitectsControllerRemoveMutationResponse, ArchitectsControllerRemovePathParams, ArchitectsControllerRemove401, ArchitectsControllerRemove403, ArchitectsControllerRemove404 } from "../../models/architectsController/ArchitectsControllerRemove";

function getArchitectsControllerRemoveUrl(id: ArchitectsControllerRemovePathParams["id"]) {
  const res = { method: 'DELETE', url: `/api/v1/architects/${id}` as const }  
  return res
}

/**
 * @summary Delete an architect
 * {@link /api/v1/architects/:id}
 */
export async function architectsControllerRemove(id: ArchitectsControllerRemovePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ArchitectsControllerRemoveMutationResponse, ResponseErrorConfig<ArchitectsControllerRemove401 | ArchitectsControllerRemove403 | ArchitectsControllerRemove404>, unknown>({ method : "DELETE", url : getArchitectsControllerRemoveUrl(id).url.toString(), ... requestConfig })  
  return res.data
}